import { STYLES_VARIABLES } from 'constants/styleVariables';
import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg';
import useModal from 'hooks/useModal';
import ModalWrapper from 'components/common/overlays/ModalWrapper';

type TProps = {
  text: string;
};

const CheckPatientComplaint = ({ text }: TProps) => {
  const { closeModal } = useModal();

  return (
    <ModalWrapper>
      <div className="flex justify_between">
        <h1 className="fs24 fw700">주요 호소 증상</h1>
        <button type="button" onClick={closeModal}>
          <CloseIcon alt="close" fill={STYLES_VARIABLES.GRAY_07} />
        </button>
      </div>
      <p className="mt18 lh24">{text}</p>
    </ModalWrapper>
  );
};

export default CheckPatientComplaint;
